import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Tooltip } from './tooltip'

export interface ExternalActionLinkProps {
  href: string
  label: string
  icon?: ReactNode
  tooltip?: string
  size?: 'sm' | 'md'
  onClick?: () => void
  className?: string
}
export function ExternalActionLink({
  href,
  label,
  icon,
  tooltip,
  size = 'sm',
  onClick,
  className,
}: ExternalActionLinkProps) {
  const link = (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={clsx(
        'flex w-fit max-w-full items-center gap-[7px] text-left text-blue',
        size === 'sm' ? 'text-[13px]' : 'text-sm',
        className
      )}
    >
      {icon}
      <span className="underline">{label}</span>
    </a>
  )
  return tooltip ? <Tooltip text={tooltip} render={link} /> : link
}
